import { useSyncExternalStore } from 'react';

/**
 * Come si mostra l'azione persistente (#385) nella schermata corrente. Luca, L-2234 (a), 2026-09-25
 * 15:20:13Z, testuale: «(a) resta, ridotta a una riga, e si nasconde mentre scrivi» — detto della
 * conversazione DM: la conversazione mette `riga`, e `nascosta` finche' la casella ha il fuoco.
 * Chi lo cambia lo rimette a `piena` quando se ne va.
 */
export type ModoBarraAzione = 'piena' | 'riga' | 'nascosta';

let modo: ModoBarraAzione = 'piena';
const ascoltatori = new Set<() => void>();

export function impostaModoBarraAzione(nuovo: ModoBarraAzione): void {
  if (nuovo === modo) return;
  modo = nuovo;
  ascoltatori.forEach((f) => f());
}
const leggi = () => modo;
const iscrivi = (f: () => void) => {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
};
export function useModoBarraAzione(): ModoBarraAzione {
  return useSyncExternalStore(iscrivi, leggi, leggi);
}
